export default __webpack_public_path__ + "static/media/big-green-vaccine.782c6e29.svg";